import { defineComponent as _defineComponent } from 'vue'
import Alert from '@sh/components/Utils/Alert/Alert.ts.vue';
import OptimizerIconV2 from '@sh/components/Utils/OptimizerIconV2.ts.vue';
import { api } from '@sh/services/api';
import router from '@sh/services/router';
import session from '@sh/services/session';
import { AlertStyle, AlertType } from '@sh/types';
import Joi from 'joi';
import { computed, ref } from 'vue';

enum FormFields {
  username = 'username',
  password = 'password',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginForm.ts',
  setup(__props) {

const isFormLoading = ref(false);

const form = ref({
  [FormFields.username]: '',
  [FormFields.password]: '',
});

const touched = ref({
  [FormFields.username]: false,
  [FormFields.password]: false,
});

const formError = ref({
  title: '',
  message: '',
});

const alertAction = computed(() => {
  if (formError.value.title === 'No Active Subscription') {
    return {
      text: 'Renew your subscription.',
      type: 'link' as const,
      href: 'https://membership.theoptimizer.io/login',
    };
  }
});

const schema = Joi.object({
  [FormFields.username]: Joi.string().required().messages({
    'string.empty': `Username field is required.`,
  }),
  [FormFields.password]: Joi.string().required().messages({
    'string.empty': `Password field is required.`,
  }),
});

const errors = computed(() => {
  const validate = schema.validate(form.value, { abortEarly: false });
  return validate.error?.details.reduce((acc, curr) => {
    acc[curr.context?.key as FormFields] = curr.message;
    return acc;
  }, {} as Record<FormFields, string>);
});

function markFieldAsTouched(field: FormFields) {
  touched.value[field] = true;
}

function markAllFieldsAsTouched() {
  Object.keys(touched.value).forEach((field) => {
    touched.value[field as FormFields] = true;
  });
}

function setFormError(title: string, message: string) {
  formError.value = { title, message };
}

function handleSessionToken(token: string) {
  session.setToken(token);

  if (session.isAuthenticated()) {
    router.push({ name: 'Home' });
  } else {
    formError.value = { title: 'Wrong token received.', message: 'Please try again.' };
  }
}

function handleApiError(err: any) {
  const { status, data } = err.response;

  switch (status) {
    case 401:
      setFormError('Bad Credentials', 'The username or password is incorrect.');
      break;
    case 400:
      if (data?.message?.includes('No active subscription')) {
        setFormError(
          'No Active Subscription',
          'You currently do not have an active subscription. Please renew your subscription to continue using TheOptimizer.'
        );
      } else {
        setFormError('Error', 'Please try again later.');
      }
      break;
    default:
      setFormError('An Error Occurred', 'Please try again later.');
  }
}

async function logIn() {
  isFormLoading.value = true;

  try {
    const { token } = await api.auth.login(form.value[FormFields.username], form.value[FormFields.password]);
    if (token) {
      handleSessionToken(token);
    } else {
      setFormError('An error ocurred', 'Please try again later.');
    }
  } catch (err: any) {
    handleApiError(err);
  }

  isFormLoading.value = false;
}

function onSubmit(event: Event) {
  event.preventDefault();
  markAllFieldsAsTouched();

  if (Object.keys(errors.value ?? {}).length) return;

  logIn();
}

return { __sfc: true,FormFields, isFormLoading, form, touched, formError, alertAction, schema, errors, markFieldAsTouched, markAllFieldsAsTouched, setFormError, handleSessionToken, handleApiError, logIn, onSubmit, Alert, OptimizerIconV2, AlertStyle, AlertType }
}

})